import { useFlags } from "launchdarkly-react-client-sdk";
import { LD_FEATURE_FLAGS } from "types/context";

export const useUpserveRebranding = () => {
  const flags = useFlags();
  return Boolean(flags[LD_FEATURE_FLAGS.upserveHqRebranding]);
};
